import { render, staticRenderFns } from "./moons-menu.svg.vue?vue&type=template&id=60bd1f7e&"
import script from "./moons-menu.svg.vue?vue&type=script&lang=js&"
export * from "./moons-menu.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports